import React, { useState } from 'react';
import { FaLinkedin, FaChevronRight, FaChevronDown } from 'react-icons/fa';

const NavBar = () => {
  const [isPortfolioOpen, setIsPortfolioOpen] = useState(true);
  const [isNavigationOpen, setIsNavigationOpen] = useState(true);
  const [isConnectOpen, setIsConnectOpen] = useState(true);
  return (
    <nav className="bg-gray-900 text-gray-300 w-64 h-screen fixed top-0 left-0 py-6 hidden md:block border-r border-gray-700">
      <div className="text-left px-6">
        {/* Project Root */}
        <div className="mb-8">
          <div 
            className="flex items-center text-white font-medium text-xl cursor-pointer hover:text-gray-300"
            onClick={() => setIsPortfolioOpen(!isPortfolioOpen)}
          >
            {isPortfolioOpen ? <FaChevronDown size={20} className="mr-2" /> : <FaChevronRight size={20} className="mr-2" />}
            <span>PORTFOLIO</span>
          </div>
          {/* Vertical line connecting to file explorer - centered on .gitignore dot */}
          {isPortfolioOpen && (
            <div 
              className={`absolute left-6 w-px bg-gray-600 transition-all duration-300 ${
                isNavigationOpen && isConnectOpen 
                  ? 'top-20 h-60' 
                  : !isNavigationOpen && isConnectOpen 
                  ? 'top-20 h-40' 
                  : isNavigationOpen && !isConnectOpen 
                  ? 'top-20 h-52' 
                  : 'top-20 h-28'
              }`}
            ></div>
          )}
        </div>

        {/* Navigation */}
        {isPortfolioOpen && (
          <div className="mb-8 ml-6">
            <div 
              className="flex items-center text-white text-base font-semibold mb-3 uppercase tracking-wider cursor-pointer hover:text-gray-300"
              onClick={() => setIsNavigationOpen(!isNavigationOpen)}
            >
              {isNavigationOpen ? <FaChevronDown size={14} className="mr-2" /> : <FaChevronRight size={14} className="mr-2" />}
              <span>Navigation</span>
            </div>
            {isNavigationOpen && (
              <ul className="space-y-2 ml-4">
                <li>
                  <a href="#about" className="flex items-center text-blue-400 hover:text-white transition-colors text-lg">
                    <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                    <span>About</span>
                  </a>
                </li>
                <li>
                  <a href="#projects" className="flex items-center text-blue-400 hover:text-white transition-colors text-lg">
                    <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                    <span>Projects</span>
                  </a>
                </li>
                <li>
                  <a href="#work" className="flex items-center text-blue-400 hover:text-white transition-colors text-lg">
                    <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                    <span>Work</span>
                  </a>
                </li>
              </ul>
            )}
          </div>
        )}

        {/* Social Links */}
        {isPortfolioOpen && (
          <div className="mb-8 ml-6">
            <div 
              className="flex items-center text-white text-base font-semibold mb-3 uppercase tracking-wider cursor-pointer hover:text-gray-300"
              onClick={() => setIsConnectOpen(!isConnectOpen)}
            >
              {isConnectOpen ? <FaChevronDown size={14} className="mr-2" /> : <FaChevronRight size={14} className="mr-2" />}
              <span>Connect</span>
            </div>
            {isConnectOpen && (
              <div className="space-y-2 ml-4">
                <a href="https://www.linkedin.com/in/zacharynobunaga/" target="_blank" rel="noopener noreferrer" className="flex items-center text-blue-400 hover:text-white transition-colors text-lg">
                  <FaLinkedin size={18} className="mr-3" />
                  <span>LinkedIn</span>
                </a>
              </div>
            )}
          </div>
        )}

        {/* File Explorer - Bottom Section */}
        {isPortfolioOpen && (
          <div className="mt-auto pt-4">
            <div className="space-y-1 text-base">
              <div className="flex items-center text-gray-400 hover:text-white cursor-pointer">
                <span>.gitignore</span>
              </div>
              <div className="flex items-center text-gray-400 hover:text-white cursor-pointer">
                <span>package-lock.json</span>
              </div>
              <div className="flex items-center text-gray-400 hover:text-white cursor-pointer">
                <span>package.json</span>
              </div>
              <div className="flex items-center text-gray-400 hover:text-white cursor-pointer">
                <span>postcss.config.js</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;

